
export const config = (url, module = "") => {
  const headers = {
    Authorization: `Bearer ${localStorage.getItem("KarbonoaTOKEN")}`,
    platform: "karbonoa",
    module: module
  };

  let urlDocuments = `${process.env.REACT_APP_API}${url}`

  return {
    url :urlDocuments,
    module,

    process: { headers, module },

    revert: null,
    restore: { headers },
    load: { headers },
    fetch: { headers },
  };
};


